import React from 'react';
import { Button } from 'reactstrap';

const CompleteOrderButton = ({ shipmentId, orderId, onOpen, label = 'Complete', colorClass = 'btn btn-success', actionType = 'complete', stopLabel = null }) => {
  const handleClick = event => {
    event.preventDefault();
    event.stopPropagation();

    if (onOpen) {
      onOpen({ shipmentId, orderId, actionType, stopLabel });
    }
  };

  return (
    <Button size="sm" className={colorClass} onMouseDown={event => event.stopPropagation()} onClick={handleClick} style={{ padding: '5px 10px' }}>
      {label}
    </Button>
  );
};

export default CompleteOrderButton;
